document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-crow-carousel]').forEach(function (root) {
    var slides = root.querySelectorAll('.crow-carousel-slide');
    var dots = root.querySelectorAll('[data-carousel-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    var nextBtn = root.querySelector('[data-carousel-next]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { show(n); restart(); });
    });

    function restart() {
      if (!root.dataset.autoplay) return;
      clearInterval(timer);
      timer = setInterval(next, parseFloat(root.dataset.autoplay) * 1000);
    }

    restart();
  });
});